export const UPDATE_GROUP_DELIVERY_DAY_ACTION = 'UPDATE_GROUP_DELIVERY_DAY_ACTION';
export const LOAD_STREET_LIST_ACTION = 'LOAD_STREET_LIST_ACTION';
export const FETCH_ADDRESS_ELIGIBILITY_LAD = 'FETCH_ADDRESS_ELIGIBILITY_LAD';
